<template>
<nav class="tab-section-nav">
  <ul class="tab-section-menu">
    <li :key="item.name" v-for="item in navItems">
      <TabButton @changedTab="changeTab" :item="item" />
    </li>
  </ul>
</nav>
</template>

<script>
import TabButton from '../TabButton/TabButton';

export default {
  name: 'TabNavigation',
  props: {
    navItems: {
      type: Array,
      required: true
    }
  },
  components: {
    TabButton
  },
  methods: {
    changeTab(payload) {
      this.$emit('changedTab', {
        tab: payload.tab
      });
    }
  }
};
</script>

<style lang="scss" scoped>

@import '../../assets/sass/config';

.tab-section-nav {
  max-width: 1000px;
  width: 100%;
  margin: auto;
}

.tab-section-menu {
  text-align: center;
  padding: 0;
  margin: 0 0 20px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  li {
    height: 52px;
    padding: 0 5px;
    margin: 5px 0;
    // flex-grow: 1;
    // flex-shrink: 1px;
    list-style: none;
    width: (100% / 7);

    @media (max-width: 768px) {
      width: (100% / 3);
    }

    @media (max-width: 568px) {
      width: 50%;
    }

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 0;
    }
  }
}
</style>
